import { useSyncExternalStore } from 'react';
import { getSorTokenSnapshot, subscribeSorToken } from './sorTokenStore';

/**
 * The app-wide SOR token (see sorTokenStore), re-rendering when it is set, renewed or dropped.
 * null while SOR is off for the tenant or before <SorTokenSync> has fetched it. Never fetches.
 */
export function useSorToken(): string | null {
  return useSyncExternalStore(subscribeSorToken, getSorTokenSnapshot, getSorTokenSnapshot);
}
